
import { Wrench, TrendingUp, Trophy, ClipboardList, Lightbulb, type LucideIcon } from "lucide-react";

export type ArticleType = "TECHNICAL" | "VALUE" | "SUCCESS_STORY" | "SOP";
export type TechnicalKind = "SOLUTION" | "GENERIC_FIX";

export const TYPE_LABELS: Record<ArticleType, string> = {
  TECHNICAL: "Technical",
  VALUE: "Value",
  SUCCESS_STORY: "Success Story",
  SOP: "SOP",
};

export const PICKER_CARDS: {
  key: string;
  type: ArticleType;
  kind: TechnicalKind | null;
  label: string;
  tag: string;
  description: string;
  icon: LucideIcon;
  tint: { icon: string; tag: string };
}[] = [
  {
    key: "VALUE",
    type: "VALUE",
    kind: null,
    label: "Value",
    tag: "4 Ps framework",
    description: "The 4P value framework: Problem, Possible, Probable, Provable, with an optional checkpoint date.",
    icon: TrendingUp,
    tint: {
      icon: "bg-brand-chip-bg/10 text-brand-chip-foreground",
      tag: "bg-brand-chip-bg/10 text-brand-chip-foreground",
    },
  },
  {
    key: "SOLUTION",
    type: "TECHNICAL",
    kind: "SOLUTION",
    label: "WalkMe Solution",
    tag: "Use case",
    description: "A real WalkMe use case: a description and a video walkthrough.",
    icon: Lightbulb,
    tint: {
      icon: "bg-info-subtle text-info",
      tag: "bg-info-subtle text-info-strong",
    },
  },
  {
    key: "GENERIC_FIX",
    type: "TECHNICAL",
    kind: "GENERIC_FIX",
    label: "Generic Fix",
    tag: "Reusable",
    description: "A reusable fix, not tied to one client or platform: context, prerequisites, steps and known issues.",
    icon: Wrench,
    tint: {
      icon: "bg-success-subtle text-success",
      tag: "bg-success-subtle text-success-strong",
    },
  },
  {
    key: "SUCCESS_STORY",
    type: "SUCCESS_STORY",
    kind: null,
    label: "Success Story",
    tag: "Customer story",
    description: "A one-page case: The Problem, The Goal, The Solution, Business Impact and Solution Outcomes, with an optional quote.",
    icon: Trophy,
    tint: {
      icon: "bg-warning-subtle text-warning",
      tag: "bg-warning-subtle text-warning-strong",
    },
  },
  {
    key: "SOP",
    type: "SOP",
    kind: null,
    label: "SOP",
    tag: "Procedure",
    description: "A standard operating procedure: steps written up in the description, with files and tags.",
    icon: ClipboardList,
    tint: {
      icon: "bg-surface-raised text-fg",
      tag: "bg-surface-raised text-fg-soft",
    },
  },
];
